(() => {
  const homePath = "/";
  const storiesPath = "/pages/stories";
  const landPaths = new Set([
    "/pages/mystery-and-mischief",
    "/pages/heart-and-belonging",
    "/pages/adventure-and-discovery",
    "/pages/wonder-and-lore",
    "/pages/laughs-and-play"
  ]);

  function setLinkLabel(link, label) {
    const textNode = Array.from(link.childNodes).find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
    if (textNode) {
      textNode.textContent = label;
    } else {
      const span = link.querySelector("span");
      if (span) span.textContent = label;
      else link.textContent = label;
    }
  }

  function updateNavigation() {
    document.querySelectorAll(".header__inline-menu, .menu-drawer__navigation").forEach((nav) => {
      const links = Array.from(nav.querySelectorAll("a"));
      const homeLabel = links.find((link) => new URL(link.href, location.origin).pathname === homePath && link.textContent.trim().toLowerCase() === "home");
      const landLink = links.find((link) => new URL(link.href, location.origin).pathname === storiesPath);
      if (landLink) {
        landLink.href = homePath;
        setLinkLabel(landLink, "Unicornland");
        if (homeLabel) homeLabel.remove();
      } else if (homeLabel) {
        setLinkLabel(homeLabel, "Unicornland");
      }
    });
  }


  function renderHolidayPage() {
    if (location.pathname.replace(/\/$/, "") !== "/pages/unicornland-holidays") return false;
    const main = document.querySelector("#MainContent");
    if (!main) return false;
    const html = [
      '<div class="unicornland-holiday-page" style="max-width:820px;margin:0 auto;padding:24px 16px;">',
      '<h1>Unicornland Holidays</h1>',
      '<p>Explore seasonal stories from Unicornland: holiday classics, Santa’s storybooks, and a tale of renewal.</p>',
      '<section style="margin:32px 0;"><h2>A Christmas Carol</h2><p>A short video storybook of the holiday classic, read by Santa.</p>',
      '<div style="position:relative;width:100%;max-width:640px;margin:18px auto;aspect-ratio:16/9;overflow:hidden;border-radius:12px;background:#111;"><iframe src="https://www.youtube-nocookie.com/embed/DvamVLib5qY" title="A Christmas Carol — Unicornland holiday story, read by Santa" loading="lazy" referrerpolicy="strict-origin-when-cross-origin" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen style="position:absolute;inset:0;width:100%;height:100%;border:0;"></iframe></div>',
      '<p><a href="https://www.youtube.com/watch?v=DvamVLib5qY" target="_blank" rel="noopener noreferrer">Watch A Christmas Carol on YouTube</a></p></section>',
      '<section style="margin:32px 0;"><h2>The Legend of Good King Wenceslas</h2><p>Unicornland’s take on the holiday classic, read by Santa.</p>',
      '<div style="position:relative;width:100%;max-width:640px;margin:18px auto;aspect-ratio:16/9;overflow:hidden;border-radius:12px;background:#111;"><iframe src="https://www.youtube-nocookie.com/embed/01etMcnr86o" title="The Legend of Good King Wenceslas — Unicornland holiday story, read by Santa" loading="lazy" referrerpolicy="strict-origin-when-cross-origin" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen style="position:absolute;inset:0;width:100%;height:100%;border:0;"></iframe></div>',
      '<p><a href="https://www.youtube.com/watch?v=01etMcnr86o" target="_blank" rel="noopener noreferrer">Watch The Legend of Good King Wenceslas on YouTube</a></p></section>',
      '<section style="margin:32px 0;"><h2>Why I Rose</h2><p>A reflective story about spiritual awakening, renewal, and finding the courage to begin again.</p>',
      '<div style="position:relative;width:100%;max-width:640px;margin:18px auto;aspect-ratio:16/9;overflow:hidden;border-radius:12px;background:#111;"><iframe src="https://www.youtube-nocookie.com/embed/bX2YqiIdOtg" title="Why I Rose by EmDubs" loading="lazy" referrerpolicy="strict-origin-when-cross-origin" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen style="position:absolute;inset:0;width:100%;height:100%;border:0;"></iframe></div>',
      '<p><a href="https://www.youtube.com/watch?v=bX2YqiIdOtg" target="_blank" rel="noopener noreferrer">Watch Why I Rose on YouTube</a> <span aria-hidden="true"> </span> <a href="/pages/why-i-rose">Explore the Why I Rose story</a></p></section>',
      '<p><a href="/pages/wonder-and-lore">← Back to Wonder &amp; Lore</a></p></div>'
    ].join("");
    main.innerHTML = html;
    document.title = "Unicornland Holidays – Unicorns and Stuff Dot Com";
    return true;
  }


  function removeDotSeparators(paragraph) {
    Array.from(paragraph.childNodes).forEach((node) => {
      if (node.nodeType === Node.TEXT_NODE && /^[\s·•]+$/.test(node.textContent)) node.textContent = " ";
      if (node.nodeType === Node.ELEMENT_NODE &&
          node.getAttribute("aria-hidden") === "true" && /^[·•]$/.test(node.textContent.trim())) node.remove();
    });
  }

  function updateLandPages() {
    const path = location.pathname.replace(/\/$/, "");
    if (!landPaths.has(path)) return;
    const rte = document.querySelector("#MainContent .rte");
    if (!rte) return;


    if (path === "/pages/wonder-and-lore") {
      rte.querySelectorAll("h3").forEach((heading) => {
        const label = heading.textContent.trim();
        if (["Why I Rose", "Charles Dickens’ A Christmas Carol", "The Legend of Good King Wenceslas"].includes(label)) {
          const videoSection = heading.closest("div[style]");
          if (videoSection && videoSection.querySelector("iframe")) videoSection.remove();
        }
      });
      rte.querySelectorAll("article").forEach((card) => {
        const heading = card.querySelector("h2, h3");
        if (heading && heading.textContent.trim() === "Why I Rose") card.remove();
      });
    }

    rte.classList.add("unicornland-land-page");
    rte.closest(".page-width--narrow")?.classList.add("unicornland-page-wide");

    const mainTitle = document.querySelector("#MainContent h1");
    const bodyTitle = rte.querySelector("h1");
    if (mainTitle && bodyTitle && mainTitle !== bodyTitle &&
        mainTitle.textContent.trim() === bodyTitle.textContent.trim()) {
      bodyTitle.remove();
    }

    rte.querySelectorAll('a[href="/pages/stories"]').forEach((link) => {
      if (/Back to Stories/i.test(link.textContent)) {
        link.href = homePath;
        setLinkLabel(link, "← Back to Unicornland");
      }
    });

    const articles = Array.from(rte.querySelectorAll("article")).filter((card) => card.querySelector("a > img"));
    if (!articles.length) return;
    const grid = articles[0].parentElement;
    if (articles.some((card) => card.parentElement !== grid)) return;
    grid.classList.add("unicornland-story-grid");

    const additions = {
      "/pages/mystery-and-mischief": [{
        title: "Numbers",
        collection: "/collections/numbers",
        image: "https://cdn.shopify.com/s/files/1/0227/3391/4184/collections/numbers-album-cover.jpg?v=1793411141",
        alt: "Numbers album cover by EmDubs",
        description: "A number-filled musical adventure, scheduled for March 14, 2027.",
        presave: "https://ditto.fm/numbers-emdubs",
        presaveLabel: "Pre-save the album"
      }],
      "/pages/adventure-and-discovery": [{
        title: "Chasing Fridays",
        collection: "/collections/chasing-fridays",
        image: "https://cdn.shopify.com/s/files/1/0227/3391/4184/collections/chasing-fridays-album-cover.jpg?v=1793408839",
        alt: "Album cover for Chasing Fridays by E. McDubs",
        description: "A new album arriving in February 2027.",
        presave: "",
        presaveLabel: ""
      }]
    };

    (additions[path] || []).forEach((item) => {
      if (grid.querySelector('a[href="' + item.collection + '"]')) return;
      const card = document.createElement("article");
      card.setAttribute("style", "border:1px solid #e4dce8;border-radius:16px;padding:16px;margin:12px 0;");
      card.innerHTML =
        '<a href="' + item.collection + '"><img src="' + item.image + '" alt="' + item.alt + '" loading="lazy" style="width:100%;height:auto;display:block;border-radius:12px;margin-bottom:12px;"></a>' +
        '<h3><a href="' + item.collection + '">' + item.title + '</a></h3>' +
        '<p>' + item.description + '</p>' +
        (item.presave ? '<p><a href="' + item.presave + '" target="_blank" rel="noopener">' + item.presaveLabel + '</a></p>' : '');
      grid.append(card);
      articles.push(card);
    });


    if (path === "/pages/wonder-and-lore" &&
        !grid.querySelector('a[href="/pages/unicornland-holidays"]')) {
      const card = document.createElement("article");
      card.setAttribute("style", "border:1px solid #e4dce8;border-radius:16px;padding:22px;margin:12px 0;background:linear-gradient(145deg,#27163f,#5b285f);color:#fff;text-align:center;min-height:210px;display:flex;align-items:center;justify-content:center;");
      card.innerHTML = '<a href="/pages/unicornland-holidays" style="display:block;color:inherit;text-decoration:none;"><span aria-hidden="true" style="display:block;font-size:32px;margin-bottom:12px;">🦄✨</span><h3 style="margin:0 0 8px;">Unicornland Holidays</h3><p style="margin:0;">Seasonal storybooks and videos from Unicornland.</p></a>';
      grid.append(card);
      articles.push(card);
    }

    articles.forEach((card) => {
      card.classList.add("unicornland-story-card");
      const titleLink = card.querySelector("h2 a[href^='/collections/'], h3 a[href^='/collections/']");
      const collectionHref = titleLink ? new URL(titleLink.href).pathname : "";

      Array.from(card.querySelectorAll("p")).forEach((paragraph) => {
        removeDotSeparators(paragraph);
        const anchors = Array.from(paragraph.querySelectorAll("a"));
        const duplicate = anchors.filter((link) =>
          /^Visit the .+ collection$/i.test(link.textContent.trim()) &&
          collectionHref &&
          new URL(link.href).pathname === collectionHref
        );
        if (!duplicate.length) return;

        const keep = anchors.filter((link) => !duplicate.includes(link));
        if (!keep.length) {
          paragraph.remove();
          return;
        }
        paragraph.replaceChildren();
        keep.forEach((link, index) => {
          if (index) paragraph.append(document.createTextNode(" "));
          link.classList.add("unicornland-story-action");
          paragraph.append(link);
        });
      });


      const cardTitle = card.querySelector("h2, h3")?.textContent.trim() || "";
      if (cardTitle === "Cryin' Wolf" || cardTitle === "Saint Paris, Ohio") {
        card.querySelectorAll("a[href*='ditto.fm/cryin-wolf'], a[href*='ditto.fm/saint-paris-ohio']").forEach((link) => setLinkLabel(link, "Stream"));
      }
      if (cardTitle === "It's Christmas!") {
        const holidayLink = card.querySelector('a[href="/collections/holiday-greeting-cards"]');
        const commercialLink = card.querySelector('a[href*="youtube.com/watch?v=5lK7Sipp7kk"]');
        const listenLink = card.querySelector('a[href*="ditto.fm/its-christmas-emdubs"]');
        if (holidayLink) setLinkLabel(holidayLink, "Holiday Greeting Cards");
        if (commercialLink) setLinkLabel(commercialLink, "Holiday Card Commercial");
        const rows = [listenLink, holidayLink, commercialLink].filter(Boolean);
        const parent = holidayLink?.closest("p") || commercialLink?.closest("p");
        if (parent && rows.length > 1) {
          const replacement = rows.map((link) => {
            const row = document.createElement("p");
            row.classList.add("unicornland-story-actions");
            row.append(link);
            return row;
          });
          parent.replaceWith(...replacement);
        }
      }

      card.querySelectorAll("p a").forEach((link) => {
        if (/^(Listen|Watch|Pre-save|Read|Download|Play|Explore)/i.test(link.textContent.trim())) {
          link.classList.add("unicornland-story-action");
          link.parentElement.classList.add("unicornland-story-actions");
        }
      });
    });
  }

  function updateStudiosPage() {
    if (location.pathname !== "/pages/unicornland-studios" && location.pathname !== "/pages/unicornland-studios/") return false;
    const main = document.querySelector("#MainContent");
    if (!main) return false;
    main.innerHTML = [
      '<section class="unicornland-studios-page" style="max-width:920px;margin:0 auto;padding:24px 16px;text-align:center;">',
      '<h1>Unicornland Studios</h1>',
      '<p style="font-size:1.15em;max-width:680px;margin:0 auto 24px;">Where imagination meets innovation, bringing a little bit of Unicornland to you!</p>',
      '<div style="position:relative;width:100%;max-width:760px;margin:24px auto 32px;aspect-ratio:16/9;overflow:hidden;border-radius:14px;background:#111;"><iframe src="https://www.youtube-nocookie.com/embed/ZcQ1PzOdzlE" title="What is Unicornland Studios?" loading="lazy" referrerpolicy="strict-origin-when-cross-origin" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen style="position:absolute;inset:0;width:100%;height:100%;border:0;"></iframe></div>',
      '<h2 style="margin:32px 0 18px;">Explore what’s free</h2>',
      '<nav aria-label="Free Unicornland resources" style="display:flex;flex-wrap:wrap;justify-content:center;gap:14px;margin:0 auto 34px;">',
      '<a href="/pages/coloring-books" style="display:inline-flex;align-items:center;justify-content:center;min-height:52px;padding:12px 22px;border-radius:999px;background:#1769d2;color:#fff;font-weight:700;text-decoration:none;border:2px solid #f5c451;">PDF Coloring Books</a>',
      '<a href="/pages/unicornlandstories" style="display:inline-flex;align-items:center;justify-content:center;min-height:52px;padding:12px 22px;border-radius:999px;background:#f5c451;color:#171717;font-weight:700;text-decoration:none;border:2px solid #1769d2;">Unicornland Stories</a>',
      '<a href="/pages/music" style="display:inline-flex;align-items:center;justify-content:center;min-height:52px;padding:12px 22px;border-radius:999px;background:#1769d2;color:#fff;font-weight:700;text-decoration:none;border:2px solid #f5c451;">Magical Music</a>',
      '</nav>',
      '<blockquote style="max-width:720px;margin:0 auto 12px;padding:18px 22px;border-left:4px solid #f5c451;text-align:left;">Unicornland Studios is a “creative powerhouse” inside Unicornland, where imagination meets innovation. We make your life a little more “unicornier”.</blockquote>',
      '</section>'
    ].join("");
    document.title = "Unicornland Studios – Unicorns and Stuff Dot Com";
    return true;
  }
  function applyUnicornlandExperience() {
    updateNavigation();
    if (renderHolidayPage()) return;
    if (updateStudiosPage()) return;
    updateLandPages();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyUnicornlandExperience, { once: true });
  } else {
    applyUnicornlandExperience();
  }
  document.addEventListener("shopify:section:load", applyUnicornlandExperience);
})();